import { render, staticRenderFns } from "./MyToolDieMachineDetails.vue?vue&type=template&id=054e6368&"
import script from "./MyToolDieMachineDetails.vue?vue&type=script&lang=js&"
export * from "./MyToolDieMachineDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyToolDieMachineDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports